import { Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "nd@nikshala.com";

export default function Contact() {
  return (
    <div className="max-w-2xl mx-auto px-6 pt-24 pb-24" data-testid="contact-page">
      <div className="text-[11px] uppercase tracking-[0.22em] text-muted font-bold">
        Ministry of Exchange
      </div>
      <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-ink" data-testid="contact-heading">
        Get in touch.
      </h1>
      <p className="mt-4 text-base text-muted max-w-lg leading-relaxed">
        One human, one inbox. No ticketing system, no auto-responder. Reach out for anything: a
        stuck visa question, a partnership idea, a bug report, or a note. We usually reply within a
        business day.
      </p>

      <a
        href={`mailto:${CONTACT_EMAIL}`}
        data-testid="contact-email-link"
        className="mt-8 inline-flex items-center gap-3 group"
      >
        <Mail size={20} className="text-elec" strokeWidth={1.8} />
        <span className="text-2xl sm:text-3xl font-bold tracking-tight text-ink group-hover:text-elec transition-colors">
          {CONTACT_EMAIL}
        </span>
        <ArrowUpRight
          size={20}
          className="text-muted group-hover:text-elec transition-colors"
          strokeWidth={1.8}
        />
      </a>

      <div className="mt-14 pt-8 border-t border-ink/10 text-sm text-muted">
        Looking for a specific route?{" "}
        <Link to="/pricing" className="text-ink font-semibold hover:text-elec">
          Concierge
        </Link>{" "}
        ·{" "}
        <Link to="/countries" className="text-ink font-semibold hover:text-elec">
          Country dossiers
        </Link>{" "}
        ·{" "}
        <Link to="/universities" className="text-ink font-semibold hover:text-elec">
          Partner universities
        </Link>
      </div>
    </div>
  );
}
